export default __webpack_public_path__ + "static/media/55-fish-bike.6ab709e7.jpg";